/* eslint-disable max-lines-per-function */
import { useEffect } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { writeCookie } from "common/utils/cookie";
import { initMixpanelEvents } from "common/utils/mixpanel/init-mixpanel-events";
import { useDtfStore } from "./store";
import "./ProColorUpsell.scss";

export default function ProColorUpsell({ artwork = null, ...restProps }) {
  const store = useDtfStore();
  const PRO_COLOR_URL = "/jiffytransfers-DTFPC1.html?ac=Transfer";

  function isStandardArtwork() {
    return store.isStandardArtwork;
  }

  function artworkId() {
    const id = Number(artwork.id) || undefined;
    return id;
  }

  function eventPayload() {
    return JSON.stringify({
      artwork_id: artworkId()
    });
  }

  function linkUrl() {
    const url = new URL(PRO_COLOR_URL, window.location.origin);
    if (artworkId()) {
      const artworkUrls = {};
      artworkUrls[artwork.id] = artwork.url;
      url.searchParams.append("artwork_urls", JSON.stringify(artworkUrls));
      url.searchParams.append("pre_cut", artwork.data.pre_cut);
      if (artwork.metadata) {
        url.searchParams.append("artwork_height", artwork.height);
        url.searchParams.append("artwork_width", artwork.width);
        url.searchParams.append("process_artwork", false);
      }
    }
    return url.pathname + url.search;
  }

  function updateUploadedArtworkIds() {
    if (artworkId()) {
      writeCookie("uploaded_artwork_ids", JSON.stringify([artworkId()]));
    }
  }

  useEffect(() => {
    initMixpanelEvents(".js-pro-color-upsell", "[data-mixpanel-event][data-mixpanel-listen]");
  }, []);

  return (
    <div {...restProps} className={cn("pro-color-upsell js-pro-color-upsell", restProps.className)}>
      {!isStandardArtwork() ? (
        <UseSvg
          className="pro-color-upsell__icon"
          icon="pro-color-wheel"
          width="52"
          height="52"
          data-testid="pro-color-upsell-icon"
        />
      ) : null}
      <div className="pro-color-upsell__content">
        <div className="pro-color-upsell__info">
          <h3 className="pro-color-upsell__title">
            {isStandardArtwork() ? (
              <>Need Professional Grade Color?</>
            ) : (
              <>Need Professional Grade Color Reproduction?</>
            )}
          </h3>
          <p className="pro-color-upsell__description">
            {" "}
            Try Jiffy ProColor transfers - print in over 16 million colors, for when precision
            matters the most.{" "}
          </p>
        </div>
        <a
          className={cn("pro-color-upsell__action", {
            "pro-color-upsell__action--standard-artwork": isStandardArtwork()
          })}
          type="button"
          href={linkUrl()}
          data-mixpanel-listen="click"
          data-mixpanel-event="pro_color_upsell_cta_click"
          data-mixpanel-data={eventPayload()}
          onClick={updateUploadedArtworkIds}
          data-testid="pro-color-upsell-action"
        >
          {isStandardArtwork() ? (
            <UseSvg
              className={cn("pro-color-upsell__icon", {
                "pro-color-upsell__icon--standard-artwork": isStandardArtwork()
              })}
              icon="pro-color-wheel"
              width="30"
              height="30"
              data-testid="pro-color-upsell-icon-1"
            />
          ) : null}{" "}
          Try Pro Color{" "}
        </a>
      </div>
    </div>
  );
}
